import React from "react";
import { motion } from "framer-motion";

const loadingContainer = {
  width: "100%",
  height: "40rem",
  background: "#111",
  display: "flex",
  justifyContent: "space-around",
  alignItems: "center", // Ensure circles are vertically centered
};
const loadingCircle = {
  display: "block",
  width: "8rem",
  height: "8rem",
  background: "#663cbd",
  borderRadius: "50%", // Changed to 50% for a perfect circle
};

const loadingContainerVariants = {
  start: {
    transition: {
      staggerChildren: 0.2,
      staggerDirection: 1, // Stagger from left to right
    },
  },
  end: {
    transition: {
      staggerChildren: 0.2,
      staggerDirection: -1, // Stagger from right to left
    },
  },
};

const loadingCircleVariants = {
  start: {
    y: "0%",
  },
  end: {
    y: "60%",
  },
};

const loadingCircleTransition = {
  duration: 0.4,
  repeat: Infinity,
  repeatType: "reverse", // This will ensure the animation reverses after reaching the end
  ease: "easeInOut",
};

const Loader = () => {
  return (
    <div>
      <div className="fixed w-full min-h-screen z-50 bg-black opacity-30" />
      <div className="flex fixed w-full justify-center items-center h-screen">
        <motion.div
          style={loadingContainer}
          variants={loadingContainerVariants}
          initial="start"
          animate="end"
        >
          <motion.span
            style={loadingCircle}
            variants={loadingCircleVariants}
            transition={loadingCircleTransition}
          ></motion.span>
          <motion.span
            style={loadingCircle}
            variants={loadingCircleVariants}
            transition={loadingCircleTransition}
          ></motion.span>
          <motion.span
            style={loadingCircle}
            variants={loadingCircleVariants}
            transition={loadingCircleTransition}
          ></motion.span>
        </motion.div>
      </div>
    </div>
  );
};

export default Loader;
